import type { TOC } from '@ember/component/template-only';
import CircleCheck from 'scaleflow/components/tailwind-icons/circle-check';

export interface RfiStatusPillSignature {
  Element: HTMLSpanElement;
  Args: {
    Named: {
      provided: boolean;
      label: string;
    };
  };
}

const RfiStatusPill: TOC<RfiStatusPillSignature> = <template>
  <span
    class="inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold
      {{if
        @provided
        'bg-green-100 text-green-800'
        'border border-gray-300 text-gray-600'
      }}"
    ...attributes
  >{{#if @provided}}<CircleCheck
        class="h-3.5 w-3.5"
        aria-hidden="true"
      />{{/if}}{{@label}}</span>
</template>;

export default RfiStatusPill;
